import React, { useState, useEffect } from "react";
import { CiSearch } from "react-icons/ci";
import { CiUser } from "react-icons/ci";
import {
  IoBagOutline,
  IoHeartOutline,
  IoLocationOutline,
} from "react-icons/io5";
import Login from "../Login/Login";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PincodeModal from "../../PincodeModal";

const Navbar0 = () => {
  const [navbarColor, setNavbarColor] = useState("#000");
  const [hoverColor, setHoverColor] = useState("transparent");
  const [navbarTextColor, setnavbarTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState({});
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [categoryCardNo, setCategoryCardNo] = useState(2);
  const accessToken = sessionStorage.getItem("accessToken");
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const navigate = useNavigate();
  const [wishlistCount, setWishlistCount] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const app_logo = sessionStorage.getItem("appLogo");
  const appName = sessionStorage.getItem("appName") || "Grobiz";
  const [logoAvailable, setLogoAvailable] = useState(false);
  const fullLogoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
  const [showModal, setShowModal] = useState(false);

  


  useEffect(() => {
    if (app_logo) {
      const fullUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
      const img = new Image();
      img.src = fullUrl;

      img.onload = () => setLogoAvailable(true);
      img.onerror = () => setLogoAvailable(false);
    }
  }, [app_logo]);

  // Add scroll event listener to close subcategory dropdown on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (activeSubcategory) {
        setActiveSubcategory(null);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSubcategory]);

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value === "") {
      setSuggestions([]);
      setShowDropdown(false);
      return; // Exit early if input is empty
    }

    if (value.length > 1) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/search_product`,
          {
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
            customer_auto_id: accessToken || admin_auto_id,
            search: value,
            limit: 15,
            page_number: 1,
          }
        );

        if (response.data.status === 1) {
          setSuggestions(response.data.get_search_products_lists || []);
          setShowDropdown(true);
        } else {
          setSuggestions([]);
          setShowDropdown(false);
        }
      } catch (error) {
        console.error("Search error:", error);
        setSuggestions([]);
        setShowDropdown(false);
      }
    } else {
      setSuggestions([]);
      setShowDropdown(false);
    }
  };
  
  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setNavbarColor(parsedStyle.nav_bar_color);
      setnavbarTextColor(parsedStyle.navbar_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setShowSearchBar(parsedStyle.show_search_bar === "Yes");
      setCategoryCardNo(parseInt(parsedStyle.categorycard_no));
    }
  }, []);

  // Fetch main categories
  // Fetch main categories and set default active category
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_main_category_list`,
          {
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
            app_type_id: sessionStorage.getItem("app_type_id"),
          }
        );
        if (response.data.status === 1) {
          const fetchedCategories = response.data.getmain_categorylist;
          setCategories(fetchedCategories);
          // Set the first category as active by default
          // if (fetchedCategories.length > 0) {
          //   setActiveCategory(fetchedCategories[0].category_auto_id);
          // }
          setActiveCategory(null);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Fetch subcategories for each category
  useEffect(() => {
    if (categories.length === 0) return;

    const fetchAllSubcategories = async () => {
      const subcategoryData = {};

      await Promise.all(
        categories.map(async (category) => {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_API_BASE_URL}/get_sub_category_list`,
              {
                admin_auto_id: sessionStorage.getItem("admin_auto_id"),
                main_category_auto_id: category.category_auto_id,
                app_type_id: sessionStorage.getItem("app_type_id"),
              }
            );

            subcategoryData[category.category_auto_id] =
              response.data.status === 1
                ? response.data.getmain_subcategorylist
                : [];
          } catch (error) {
            console.error(
              `Error fetching subcategories for category ${category.category_auto_id}:`,
              error
            );
            subcategoryData[category.category_auto_id] = [];
          }
        })
      );

      setSubcategories(subcategoryData);
    };

    fetchAllSubcategories();
  }, [categories]);

  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const goToWishlist = () => {
    !accessToken
      ? openModal()
      : navigate("/dashboard", { state: { page: "mywishlist" } });
  };

  const fetchWishlistCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_wishlist_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setWishlistCount(res.data.product_count_data);
      } else {
        setWishlistCount(0);
      }
    } catch (error) {
      setWishlistCount(0);
      console.error("Error fetching wishlist count:", error);
    }
  };

  useEffect(() => {
    const handleUserDataUpdated = () => {
      if (accessToken) {
        fetchWishlistCount();
        fetchCartCount();
      } else {
        setWishlistCount(0); // reset when not logged in
        setCartCount(0);
      }
    };

    window.addEventListener("wishlist-updated", handleUserDataUpdated);
    window.addEventListener("cart-updated", handleUserDataUpdated);

    // Initial fetch if logged in
    if (accessToken) {
      fetchWishlistCount();
      fetchCartCount();
    }

    return () => {
      window.removeEventListener("wishlist-updated", handleUserDataUpdated);
      window.removeEventListener("cart-updated", handleUserDataUpdated);
    };
  }, [accessToken]);

  const fetchCartCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setCartCount(res.data.product_count_data);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      setCartCount(0);
      console.error("Error fetching cart count:", error);
    }
  };

  const goToCart = () => {
    navigate("/cart");
  };

  // Find the selected category
  const selectedCategory = categories.find(
    (category) => category.category_auto_id === activeCategory
  );

  return (
    <nav
      className={`w-full bg-white shadow-lg ${font}`}
      style={{ color: navbarTextColor }}
    >
      {/* First Row */}
      <div className="relative flex flex-col w-full px-4 py-2 bg-black border-b border-gray-700 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        {/* Logo and Categories Container */}
        <div className="flex flex-row items-center justify-between w-full sm:justify-start sm:mb-0 sm:w-auto">
          {/* Logo Section */}
          <div className="flex-shrink-0">
            <a
              className="flex items-center text-xl font-bold text-white no-underline sm:text-2xl"
              href="/"
            >
              {logoAvailable ? (
                <img
                  src={fullLogoUrl}
                  alt="App Logo"
                  className="w-auto h-7 sm:h-8"
                />
              ) : (
                <span>{appName}</span>
              )}
            </a>
          </div>

          {/* Categories Section */}
          {categories.length > 0 && (
            <div
              className="relative ml-3 text-xs font-semibold tracking-wide text-white sm:ml-6 sm:text-sm"
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${Math.min(
                  categories.length,
                  6
                )}, minmax(0, 1fr))`,
                gap: "0.5rem",
              }}
            >
              {categories.slice(0, 6).map((category) => (
                <div
                  key={category.category_auto_id}
                  className="relative z-0 flex items-center justify-center"
                >
                  {/* Background for Active Category */}
                  {activeCategory === category.category_auto_id && (
                    <div
                      className="absolute inset-0 -top-[0.75rem] -bottom-[0.75rem] sm:-top-[0.75rem] sm:-bottom-[0.75rem] left-0 right-0 "
                      style={{
                        backgroundColor: navbarColor,
                        zIndex: -1,
                        height: "calc(100% + 1.5rem)",
                        ...(window.innerWidth >= 640
                          ? { height: "calc(100% + 1.5rem)" }
                          : {}),
                      }}
                    />
                  )}
                  <Link
                    to={`/maincategory/${category.category_auto_id}`}
                    className="px-2 py-2 text-center text-white no-underline transition-colors rounded-md hover:text-gray-300"
                    onClick={() => setActiveCategory(category.category_auto_id)}
                  >
                    <span className="whitespace-nowrap">
                      {category.category_name?.toUpperCase()}
                    </span>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Search Bar Section */}
        <div className="flex items-center justify-center flex-grow sm:justify-end sm:mb-0">
          {showSearchBar ? (
            <div className="relative w-full max-w-full sm:max-w-[550px] mx-2">
              <input
                type="text"
                className="w-full h-8 pl-3 pr-8 text-xs text-black bg-white rounded-full sm:h-9 sm:pl-4 sm:pr-10 focus:outline-none focus:ring-2 focus:ring-gray-400 sm:text-sm"
                placeholder="Search for products, brands and more"
                value={query}
                onChange={handleInputChange}
              />
              <CiSearch className="absolute text-base text-gray-500 transform -translate-y-1/2 right-2 sm:right-3 top-1/2 sm:text-lg" />
              {showDropdown && suggestions.length > 0 && (
                <ul className="absolute left-0 z-50 w-full mt-1 overflow-y-auto bg-white border rounded-lg shadow-lg top-full max-h-48 sm:max-h-60">
                  {suggestions.map((item, index) => (
                    <Link
                      key={index}
                      to={`/product-detail/${item.product_auto_id}`}
                      className="no-underline text-inherit"
                    >
                      <li
                        className="flex items-center gap-2 px-3 py-1 text-xs text-black cursor-pointer sm:gap-3 sm:px-4 sm:py-2 hover:bg-gray-100 sm:text-sm"
                        onClick={() => {
                          setQuery(item.product_name);
                          setShowDropdown(false);
                        }}
                      >
                        <img
                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images[0]?.product_image}`}
                          alt={item.product_name}
                          className="object-cover border rounded-md w-7 h-7 sm:w-10 sm:h-10"
                        />
                        <span>{item.product_name}</span>
                      </li>
                    </Link>
                  ))}
                </ul>
              )}
            </div>
          ) : (
            <div className="flex-grow" />
          )}
        </div>

        {/* Icons Section */}
        <div className="flex items-center justify-center space-x-6 text-white sm:space-x-8 ">
          <div className="relative">
            <CiUser
              className="text-xl transition-colors cursor-pointer sm:text-2xl"
              style={{ color: "white" }}
              onMouseEnter={(e) => (e.target.style.color = themeIconColor)}
              onMouseLeave={(e) => (e.target.style.color = "white")}
              onClick={() =>
                !accessToken
                  ? openModal()
                  : setShowUserDropdown(!showUserDropdown)
              }
            />
            {showUserDropdown && (
              <div className="absolute right-0 z-50 w-32 mt-2 text-black bg-white rounded-md shadow-md sm:w-36">
                <ul className="px-2 py-1">
                  <li className="py-1.5 sm:py-2 pl-3 sm:pl-4 cursor-pointer hover:bg-gray-100">
                    <Link
                      to="/dashboard"
                      className="flex items-center gap-2 no-underline text-inherit"
                    >
                      <CiUser className="text-lg sm:text-xl" />
                      <span className="text-xs sm:text-sm">Profile</span>
                    </Link>
                  </li>
                  <li
                    className="py-1.5 sm:py-2 pl-3 sm:pl-4 cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      sessionStorage.removeItem("accessToken");
                      setShowUserDropdown(false);
                      navigate("/");
                      setTimeout(() => window.location.reload(), 100);
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <FiLogOut className="text-lg sm:text-xl" />
                      <span className="text-xs sm:text-sm">Logout</span>
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>

          <div className="relative">
            <IoLocationOutline
              className="text-xl transition-colors cursor-pointer sm:text-2xl"
              style={{ color: "white" }}
              onMouseEnter={(e) => (e.target.style.color = themeIconColor)}
              onMouseLeave={(e) => (e.target.style.color = "white")}
              onClick={() => setShowModal(true)}
            />
          </div>

          <div className="relative">
            <IoHeartOutline
              className="text-xl transition-colors cursor-pointer sm:text-2xl"
              style={{ color: "white" }}
              onMouseEnter={(e) => (e.target.style.color = themeIconColor)}
              onMouseLeave={(e) => (e.target.style.color = "white")}
              onClick={goToWishlist}
            />
            {wishlistCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] sm:text-xs px-1 sm:px-1.5 py-0.5 rounded-full">
                {wishlistCount}
              </span>
            )}
          </div>

          <div className="relative">
            <IoBagOutline
              className="text-xl transition-colors cursor-pointer sm:text-2xl"
              style={{ color: "white" }}
              onMouseEnter={(e) => (e.target.style.color = themeIconColor)}
              onMouseLeave={(e) => (e.target.style.color = "white")}
              onClick={goToCart}
            />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] sm:text-xs px-1 sm:px-1.5 py-0.5 rounded-full">
                {cartCount}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Second Row */}
      {activeCategory && (
      <div className="relative border-b d-none d-lg-flex">
        <div
          className="flex items-center w-full h-12 overflow-y-auto text-center "
          style={{ backgroundColor: navbarColor }}
        >
          {selectedCategory &&
          selectedCategory.getmain_subcategorylist?.length > 0 ? (
            selectedCategory.getmain_subcategorylist
              .slice(0, 10)
              .map((subcategory) => (
                <div
                  key={subcategory.sub_category_auto_id}
                  className="ml-10 py-[11px] transition duration-300 relative group  hover:bg-opacity-20"
                  style={{
                    backgroundColor:
                      activeSubcategory === subcategory.sub_category_auto_id
                        ? `#ffffff`
                        : "transparent",

                    color:
                      activeSubcategory === subcategory.sub_category_auto_id
                        ? `#000000`
                        : "",
                  }}
                  onMouseEnter={() =>
                    setActiveSubcategory(subcategory.sub_category_auto_id)
                  }
                  onMouseLeave={() => setActiveSubcategory(null)}
                >
                  <Link
                    to="/productlist"
                    state={{
                      subcategoryName: subcategory.sub_category_name,
                      sub_cat_id: subcategory.sub_category_auto_id,
                    }}
                    className="text-white no-underline transition-colors"
                  >
                    <span
                      className="p-2 font-medium truncate cursor-pointer "
                      style={{
                        color:
                          activeSubcategory === subcategory.sub_category_auto_id
                            ? `#000000`
                            : "",
                      }}
                    >
                      {subcategory.sub_category_name}
                    </span>
                  </Link>

                  {/* Sub-subcategory Dropdown (Prepared for future data) */}
                  {activeSubcategory === subcategory.sub_category_auto_id && (
                    <div className="fixed left-1/2 -translate-x-1/2 z-50 hidden w-[calc(100%-100px)] mx-auto p-4 mt-1 bg-white rounded-lg shadow-lg group-hover:block">
                      {/* Case: Both subcategories and brands exist (two columns) */}
                      {subcategory.getmain_subsubcategorylist?.length > 0 &&
                        selectedCategory.getmain_brand_list?.length > 0 && (
                          <div className="flex">
                            {/* Sub-subcategories (Left Side) */}
                            <div className="w-1/2 pr-4 border-r">
                              <h3 className="mb-3 text-lg font-bold text-gray-400">
                                Sub-Subcategories
                              </h3>
                              <div className="grid grid-cols-2 gap-3">
                                {subcategory.getmain_subsubcategorylist.map(
                                  (subsub) => (
                                    <Link
                                      to="/subsubcatproductlist"
                                      state={{
                                        subsubcategoryName:
                                          subsub.sub_category_name,
                                          sub_sub_cat_id: subsub._id,
                                      }}
                                      className="no-underline"
                                      key={subsub.sub_category_auto_id}
                                    >
                                      <div className="flex items-center p-2 space-x-3 rounded cursor-pointer hover:bg-gray-100">
                                        <img
                                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${subsub.subcategory_image_app}`}
                                          alt={subsub.sub_category_name}
                                          className="object-cover w-10 h-10 rounded-full"
                                        />
                                        <p className="text-gray-700">
                                          {subsub.sub_category_name}
                                        </p>
                                      </div>
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>

                            {/* Brands (Right Side) */}
                            <div className="w-1/2 pl-4">
                              <h3 className="mb-3 text-lg font-bold text-gray-400">
                                Popular Brands
                              </h3>
                              <div className="grid grid-cols-3 gap-3">
                                {selectedCategory.getmain_brand_list.map(
                                  (brand) => (
                                    <Link
                                      to="/productlist"
                                      state={{
                                        brandName: brand.brand_name,
                                        brand_id: brand.brand_auto_id,
                                      }}
                                      className="no-underline"
                                      key={brand.brand_auto_id}
                                    >
                                      <div className="flex flex-col items-center p-2 rounded cursor-pointer hover:bg-gray-100">
                                        <img
                                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/brands/${brand.brand_image_app}`}
                                          alt={brand.brand_name}
                                          className="object-cover w-12 h-12 mb-1 rounded-full"
                                        />
                                        <p className="text-sm text-center text-gray-700">
                                          {brand.brand_name}
                                        </p>
                                      </div>
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                      {/* Case: Only subcategories exist */}
                      {subcategory.getmain_subsubcategorylist?.length > 0 &&
                        !selectedCategory.getmain_brand_list?.length && (
                          <div className="w-full">
                            <h3 className="mb-3 text-lg font-bold text-gray-400">
                              Sub-Subcategories
                            </h3>
                            <div className="grid grid-cols-2 gap-3">
                              {subcategory.getmain_subsubcategorylist?.length >
                                0 && (
                                <div
                                  className={`${
                                    selectedCategory.getmain_brand_list
                                      ?.length > 0
                                      ? "w-1/2 pr-4 border-r"
                                      : "w-full"
                                  }`}
                                >
                                  {categoryCardNo === 2 && (
                                    <div className="grid grid-cols-2 gap-3">
                                      {subcategory.getmain_subsubcategorylist.map(
                                        (subsub) => (
                                          <Link
                                            to="/subsubcatproductlist"
                                            state={{
                                              subsubcategoryName:
                                                subsub.sub_category_name,
                                                sub_sub_cat_id:
                                                subsub._id,
                                            }}
                                            className="no-underline"
                                            key={subsub.sub_category_auto_id}
                                          >
                                            <div className="flex items-center p-2 space-x-3 rounded cursor-pointer hover:bg-gray-100">
                                              <img
                                                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${subsub.subcategory_image_app}`}
                                                alt={subsub.sub_category_name}
                                                className="object-cover w-10 h-10 rounded-full"
                                              />
                                              <p className="text-gray-700">
                                                {subsub.sub_category_name}
                                              </p>
                                            </div>
                                          </Link>
                                        )
                                      )}
                                    </div>
                                  )}

                                  {categoryCardNo === 1 && (
                                    <div className="grid grid-cols-3 gap-3">
                                      {subcategory.getmain_subsubcategorylist.map(
                                        (subsub) => (
                                          <Link
                                            to="/productlist"
                                            state={{
                                              subcategoryName:
                                                subsub.sub_category_name,
                                              sub_cat_id:
                                                subsub.sub_category_auto_id,
                                            }}
                                            className="no-underline"
                                            key={subsub.sub_category_auto_id}
                                          >
                                            <div className="flex flex-col items-center p-2 rounded cursor-pointer hover:bg-gray-100">
                                              <img
                                                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/subcategories/${subsub.subcategory_image_app}`}
                                                alt={subsub.sub_category_name}
                                                className="object-cover w-16 h-16 mb-2 rounded-full"
                                              />
                                            </div>
                                          </Link>
                                        )
                                      )}
                                    </div>
                                  )}

                                  {categoryCardNo === 0 && (
                                    <div className="grid grid-cols-3 gap-3">
                                      {subcategory.getmain_subsubcategorylist.map(
                                        (subsub) => (
                                          <Link
                                            to="/productlist"
                                            state={{
                                              subcategoryName:
                                                subsub.sub_category_name,
                                              sub_cat_id:
                                                subsub.sub_category_auto_id,
                                            }}
                                            className="no-underline"
                                            key={subsub.sub_category_auto_id}
                                          >
                                            <div className="p-3 text-center rounded cursor-pointer hover:bg-gray-100">
                                              <p className="font-medium text-gray-700">
                                                {subsub.sub_category_name}
                                              </p>
                                            </div>
                                          </Link>
                                        )
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                      {/* Case: Only brands exist */}
                      {selectedCategory.getmain_brand_list?.length > 0 &&
                        !subcategory.getmain_subsubcategorylist?.length && (
                          <div className="w-full">
                            <h3 className="mb-3 text-lg font-bold text-gray-400">
                              Popular Brands
                            </h3>
                            <div className="grid grid-cols-3 gap-3">
                              {selectedCategory.getmain_brand_list.map(
                                (brand) => (
                                  <Link
                                    to="/brandlist"
                                    state={{
                                      brandName: brand.brand_name,
                                      brand_id: brand.brand_auto_id,
                                    }}
                                    className="no-underline"
                                    key={brand.brand_auto_id}
                                  >
                                    <div className="flex flex-col items-center p-2 rounded cursor-pointer hover:bg-gray-100">
                                      <img
                                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/brands/${brand.brand_image_app}`}
                                        alt={brand.brand_name}
                                        className="object-cover w-12 h-12 mb-1 rounded-full"
                                      />
                                      <p className="text-sm text-center text-gray-700">
                                        {brand.brand_name}
                                      </p>
                                    </div>
                                  </Link>
                                )
                              )}
                            </div>
                          </div>
                        )}

                      {/* Case: No data */}
                      {!subcategory.getmain_subsubcategorylist?.length &&
                        !selectedCategory.getmain_brand_list?.length && (
                          <div className="w-full p-4 text-center">
                            <p className="text-gray-500">
                              No data available for this category
                            </p>
                          </div>
                        )}
                    </div>
                  )}
                </div>
              ))
          ) : (
            <div className="py-3 ml-5 text-black">
              No subsubcategories available
            </div>
          )}
        </div>
      </div>
      )}
      {/* Third Row -  Desktop view */}
      {/* {categories.length >= 3 && (
        <div
          className="flex-col items-center justify-between hidden w-full text-center md:flex md:flex-row"
          style={{ backgroundColor: `${navbarColor}40` }}
        >
          <Link
            to={`/maincategory/${
              categories[categories.length - 3]?.category_auto_id
            }`}
            className="no-underline text-inherit"
          >
            <button
              className="border-2 p-1 border-[color:var(--borderColor)] m-1 font-bold"
              style={{
                "--borderColor": navbarTextColor,
              }}
            >
              {categories[categories.length - 3]?.category_name}
            </button>
          </Link>

          <Link
            to={`/maincategory/${
              categories[categories.length - 2]?.category_auto_id
            }`}
            className="no-underline text-inherit"
          >
            <button
              className="p-1 hover:border-[color:var(--hoverborderColor)] w-96 m-1 font-bold"
              style={{
                "--hoverborderColor": navbarColor,
              }}
            >
              {categories[categories.length - 2]?.category_name}
            </button>
          </Link>

          <Link
            to={`/maincategory/${
              categories[categories.length - 1]?.category_auto_id
            }`}
            className="no-underline text-inherit"
          >
            <button
              className="border-2 p-1 border-[color:var(--borderColor)] m-1 font-bold"
              style={{
                "--borderColor": navbarTextColor,
              }}
            >
              {categories[categories.length - 1]?.category_name}
            </button>
          </Link>
        </div>
      )} */}

      {/* mobile view: Third Row */}
      {/* <div
        className="flex flex-col items-center justify-between w-full text-center md:hidden"
        style={{ backgroundColor: `${navbarColor}40` }}
      >
        <div className="flex items-center justify-between">
      
          {categories.slice(0, 2).map((category) => (
            <Link
              to={`/maincategory/${category.category_auto_id}`}
              className="no-underline text-inherit"
            >
              <button
                key={category.category_auto_id}
                className="border-2 p-1 border-[color:var(--borderColor)] m-1 font-bold"
                style={{
                  "--borderColor": navbarTextColor, // Dynamic border color
                }}
              >
                {category.category_name}
              </button>
            </Link>
          ))}
        </div>
      </div> */}

      {isOpen && <Login isOpen={isOpen} onClose={closeModal} />}
      <PincodeModal showModal={showModal} setShowModal={setShowModal} />
    </nav>
  );
};
export default Navbar0;
